import clsx from 'clsx'

export type TimelineCardProps = {
  title: string
  body: string
  isActive?: boolean
  isCompleted?: boolean
}

export default function TimelineCard ({ title, body, isCompleted }: TimelineCardProps) {
  return (
    <div className='flex flex-col gap-2 p-4 bg-white border border-gray-200 rounded-2xl shadow-sm'>
      <div className={clsx('body-bold', {
        'text-green-500': isCompleted,
      })}
      >{isCompleted ? 'Confirmed' : title}
      </div>
      <p className='body-sm text-gray-500'>{body}</p>
    </div>
  )
}
